import hasActiveContracts from '@/mixins/hasActiveContracts'
import { MerchantCurrencyGQL } from '@/graphql/queries'

export default {
  mixins: [hasActiveContracts],

  apollo: {
    merchantDefaultCurrency: {
      query: MerchantCurrencyGQL,
      update: data => data.merchant.currency,
      skip () { return !this.hasActiveContracts }
    }
  },

  computed: {
    merchantCurrency () {
      if (!this.merchantDefaultCurrency) {
        return null
      }

      return this.merchantDefaultCurrency
    }
  }
}
